// extracted by mini-css-extract-plugin
export var deliveryRow = "_qc-a";
export var fixedHeight = "_qc-4";
export var freightLogo = "_qc-9";
export var fullWidth = "_qc-3";
export var priceColumn = "_qc-5";
export var radioSelected = "_qc-7";
export var radioUnselected = "_qc-6";
export var selectedOption = "_qc-2";
export var selectedOptionContainer = "_qc-1";
export var selection = "_qc-0";
export var tallSkeletonText = "_qc-8";